import * as i0 from '@angular/core';
import * as i1 from './meta-ui-layout.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/cdk/bidi';
import * as i5 from '@angular/material/icon';
import * as i6 from '@angular/material/card';
import * as i7 from '@angular/material/button';
import * as i8 from '@angular/material/form-field';
import * as i9 from '@ngx-metaui/rules';
import * as i10 from '@angular/cdk/scrolling';
import * as i11 from '@angular/material/core';
import * as i12 from '@angular/material/autocomplete';
import * as i13 from '../ui/input/input.component';
import * as i14 from '../ui/string/string.component';
import * as i15 from '../ui/text-area/text-area.component';
import * as i16 from '../ui/select/select.component';
import * as i17 from '../ui/checkbox/checkbox.component';
import * as i18 from '../ui/radio-group/radio-group.component';
import * as i19 from '../ui/date-picker/date-picker.component';
import * as i20 from '../ui/autocomplete/autocomplete.component';
import * as i21 from '../ui/button/button.component';
import * as i22 from '@angular/router';
import * as i23 from './meta-form/meta-form-group.component';
import * as i24 from './meta-form/form-field-adapter.directive';
import * as i25 from './meta-content-page/meta-content-page.component';
import * as i26 from './meta-action-list/meta-action-list.component';
import * as i27 from './meta-element-list/meta-element-list.component';
import * as i28 from '@angular/platform-browser/animations';
import * as i29 from '../ui/ui.module';
export const LayoutModuleNgFactory:i0.NgModuleFactory<i1.LayoutModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_ba = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.NumberValueAccessor = (<any>(null as any));
var _decl0_16:i3.RangeValueAccessor = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i4.Dir = (<any>(null as any));
var _decl0_33:i5.MatIcon = (<any>(null as any));
var _decl0_34:i6.MatCard = (<any>(null as any));
var _decl0_35:i6.MatCardHeader = (<any>(null as any));
var _decl0_36:i6.MatCardTitleGroup = (<any>(null as any));
var _decl0_37:i6.MatCardContent = (<any>(null as any));
var _decl0_38:i6.MatCardTitle = (<any>(null as any));
var _decl0_39:i6.MatCardSubtitle = (<any>(null as any));
var _decl0_40:i6.MatCardActions = (<any>(null as any));
var _decl0_41:i6.MatCardFooter = (<any>(null as any));
var _decl0_42:i6.MatCardSmImage = (<any>(null as any));
var _decl0_43:i6.MatCardMdImage = (<any>(null as any));
var _decl0_44:i6.MatCardLgImage = (<any>(null as any));
var _decl0_45:i6.MatCardImage = (<any>(null as any));
var _decl0_46:i6.MatCardXlImage = (<any>(null as any));
var _decl0_47:i6.MatCardAvatar = (<any>(null as any));
var _decl0_48:i7.MatButton = (<any>(null as any));
var _decl0_49:i7.MatAnchor = (<any>(null as any));
var _decl0_50:i8.MatError = (<any>(null as any));
var _decl0_51:i8.MatFormField = (<any>(null as any));
var _decl0_52:i8.MatHint = (<any>(null as any));
var _decl0_53:i8.MatLabel = (<any>(null as any));
var _decl0_54:i8.MatPlaceholder = (<any>(null as any));
var _decl0_55:i8.MatPrefix = (<any>(null as any));
var _decl0_56:i8.MatSuffix = (<any>(null as any));
var _decl0_57:i9.MetaContextComponent = (<any>(null as any));
var _decl0_58:i9.MetaRendererComponent = (<any>(null as any));
var _decl0_59:i9.ɵh = (<any>(null as any));
var _decl0_60:i9.GenericContainerComponent = (<any>(null as any));
var _decl0_61:i10.CdkScrollable = (<any>(null as any));
var _decl0_62:i11.MatOption = (<any>(null as any));
var _decl0_63:i11.MatOptgroup = (<any>(null as any));
var _decl0_64:i12.MatAutocomplete = (<any>(null as any));
var _decl0_65:i12.MatAutocompleteTrigger = (<any>(null as any));
var _decl0_66:i12.MatAutocompleteOrigin = (<any>(null as any));
var _decl0_67:i13.InputField = (<any>(null as any));
var _decl0_68:i14.StringField = (<any>(null as any));
var _decl0_69:i15.TextArea = (<any>(null as any));
var _decl0_70:i16.Select = (<any>(null as any));
var _decl0_71:i17.Checkbox = (<any>(null as any));
var _decl0_72:i18.RadioGroup = (<any>(null as any));
var _decl0_73:i19.DatePicker = (<any>(null as any));
var _decl0_74:i20.AutoComplete = (<any>(null as any));
var _decl0_75:i21.Button = (<any>(null as any));
var _decl0_76:i22.RouterOutlet = (<any>(null as any));
var _decl0_77:i22.RouterLink = (<any>(null as any));
var _decl0_78:i22.RouterLinkWithHref = (<any>(null as any));
var _decl0_79:i22.RouterLinkActive = (<any>(null as any));
var _decl0_80:i22.ɵangular_packages_router_router_l = (<any>(null as any));
var _decl0_81:i23.MetaFormGroup = (<any>(null as any));
var _decl0_82:i24.MetaFFAdapter = (<any>(null as any));
var _decl0_83:i25.MetaContentPageComponent = (<any>(null as any));
var _decl0_84:i26.MetaActionListComponent = (<any>(null as any));
var _decl0_85:i27.MetaElementListComponent = (<any>(null as any));
var _decl0_86:i2.AsyncPipe = (<any>(null as any));
var _decl0_87:i2.UpperCasePipe = (<any>(null as any));
var _decl0_88:i2.LowerCasePipe = (<any>(null as any));
var _decl0_89:i2.JsonPipe = (<any>(null as any));
var _decl0_90:i2.SlicePipe = (<any>(null as any));
var _decl0_91:i2.DecimalPipe = (<any>(null as any));
var _decl0_92:i2.PercentPipe = (<any>(null as any));
var _decl0_93:i2.TitleCasePipe = (<any>(null as any));
var _decl0_94:i2.CurrencyPipe = (<any>(null as any));
var _decl0_95:i2.DatePipe = (<any>(null as any));
var _decl0_96:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_97:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_98:i2.KeyValuePipe = (<any>(null as any));
var _decl0_99:i9.ContextPropertyPipe = (<any>(null as any));
var _decl0_100:i2.CommonModule = (<any>(null as any));
var _decl0_101:i3.FormsModule = (<any>(null as any));
var _decl0_102:i28.BrowserAnimationsModule = (<any>(null as any));
var _decl0_103:i5.MatIconModule = (<any>(null as any));
var _decl0_104:i6.MatCardModule = (<any>(null as any));
var _decl0_105:i7.MatButtonModule = (<any>(null as any));
var _decl0_106:i8.MatFormFieldModule = (<any>(null as any));
var _decl0_107:i9.MetaUIRulesModule = (<any>(null as any));
var _decl0_110:i29.UIModule = (<any>(null as any));
var _decl0_109:i22.RouterModule = (<any>(null as any));
var _decl0_111:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_112:i0.ElementRef<any> = (<any>(null as any));
function _View_MetaFormGroup_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_MetaFormGroup_1_2():void {
  if (_decl0_57.hasObject()) { var _any:any = (null as any); }
}
function _View_MetaFormGroup_1_1():void {
  if (_decl0_57.hasObject()) {
    var _any:any = (null as any);
    const currVal_0:any = (_decl0_34._animationMode === 'NoopAnimations');
    currVal_0;
    const currVal_1:any = {$implicit:_decl0_57};
    currVal_1;
    const currVal_2:any = _decl0_111;
    currVal_2;
  }
}
function _View_MetaFormGroup_1_4():void {
  var _any:any = (null as any);
}
function _View_MetaFormGroup_1_6():void {
  var _any:any = (null as any);
}
function _View_MetaFormGroup_1_5():void {
  var _any:any = (null as any);
  const currVal_0:any = 'col-xs-12';
  currVal_0;
  const currVal_1:any = {'col-sm-6 col-md-6 col-lg-6':!_any.isFullWidth};
  currVal_1;
  const currVal_2:any = !_decl0_81.editing;
  currVal_2;
  const currVal_3:any = _any.orderNum;
  currVal_3;
  const currVal_4:any = {$implicit:_any.name,mc:_any};
  currVal_4;
  const currVal_5:any = _decl0_111;
  currVal_5;
}
function _View_MetaFormGroup_1_7():void {
  var _any:any = (null as any);
}
function _View_MetaFormGroup_1_3():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_34._animationMode === 'NoopAnimations');
  currVal_0;
  const currVal_1:any = {$implicit:'fieldsByZone.zTop',mc:_any};
  currVal_1;
  const currVal_2:any = _decl0_111;
  currVal_2;
  const currVal_3:any = _decl0_81.mainZones;
  currVal_3;
  const currVal_4:any = _decl0_81.trackByFieldName;
  currVal_4;
  const currVal_5:any = {$implicit:'fieldsByZone.zBottoms',mc:_any};
  currVal_5;
  const currVal_6:any = _decl0_111;
  currVal_6;
}
function _View_MetaFormGroup_1_11():void {
  if (_decl0_99.transform(_any,_any)) { var _any:any = (null as any); }
}
function _View_MetaFormGroup_1_10():void {
  if (_decl0_99.transform(_any,_any)) {
    var _any:any = (null as any);
    const currVal_0:any = {$implicit:_any,mc:_any};
    currVal_0;
    const currVal_1:any = _decl0_111;
    currVal_1;
  }
}
function _View_MetaFormGroup_1_9():void {
  if (_decl0_99.transform(_any,_any)) {
    var _any:any = (null as any);
    const currVal_0:any = !!!_decl0_99.transform(_any,'editing');
    currVal_0;
    const currVal_1:any = _any;
    currVal_1;
  }
}
function _View_MetaFormGroup_1_8():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_99.transform(_any,_any);
  currVal_0;
}
function _View_MetaFormGroup_1_14():void {
  if ((!!_decl0_99.transform(_decl0_57,'visible') && !!_decl0_99.transform(_decl0_57,
      'editing'))) {
    var _any:any = (null as any);
    const currVal_0:any = 'end';
    currVal_0;
    const currVal_1:any = (_decl0_52.align === 'end');
    currVal_1;
    const currVal_2:any = _decl0_52.id;
    currVal_2;
    const currVal_3:any = null;
    currVal_3;
    const currVal_4:any = _decl0_99.transform(_decl0_57,'hint');
    currVal_4;
  }
}
function _View_MetaFormGroup_1_15():void {
  if ((!!_decl0_99.transform(_decl0_57,'visible') && ((!!_decl0_99.transform(_decl0_57,
      'editing') && !!_decl0_51._control.ngControl) && _decl0_51._control.ngControl.control.invalid))) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_50.id;
    currVal_0;
    const currVal_1:any = _decl0_51._control.ngControl.errors['metavalid'].msg;
    currVal_1;
  }
}
function _View_MetaFormGroup_1_13():void {
  if (!!_decl0_99.transform(_decl0_57,'visible')) {
    var _any:any = (null as any);
    const currVal_0:any = !!!_decl0_99.transform(_decl0_57,'required',false);
    currVal_0;
    const currVal_1:any = 'always';
    currVal_1;
    const currVal_2:any = (_decl0_51.appearance == 'standard');
    currVal_2;
    const currVal_3:any = (_decl0_51.appearance == 'fill');
    currVal_3;
    const currVal_4:any = (_decl0_51.appearance == 'outline');
    currVal_4;
    const currVal_5:any = (_decl0_51.appearance == 'legacy');
    currVal_5;
    const currVal_6:any = _decl0_51._control.errorState;
    currVal_6;
    const currVal_7:any = _decl0_51._canLabelFloat();
    currVal_7;
    const currVal_8:any = _decl0_51._shouldLabelFloat();
    currVal_8;
    const currVal_9:any = _decl0_51._hasFloatingLabel();
    currVal_9;
    const currVal_10:any = _decl0_51._hideControlPlaceholder();
    currVal_10;
    const currVal_11:any = _decl0_51._control.disabled;
    currVal_11;
    const currVal_12:any = _decl0_51._control.autofilled;
    currVal_12;
    const currVal_13:any = _decl0_51._control.focused;
    currVal_13;
    const currVal_14:any = (_decl0_51.color == 'accent');
    currVal_14;
    const currVal_15:any = (_decl0_51.color == 'warn');
    currVal_15;
    const currVal_16:any = _decl0_51._shouldForward('untouched');
    currVal_16;
    const currVal_17:any = _decl0_51._shouldForward('touched');
    currVal_17;
    const currVal_18:any = _decl0_51._shouldForward('pristine');
    currVal_18;
    const currVal_19:any = _decl0_51._shouldForward('dirty');
    currVal_19;
    const currVal_20:any = _decl0_51._shouldForward('valid');
    currVal_20;
    const currVal_21:any = _decl0_51._shouldForward('invalid');
    currVal_21;
    const currVal_22:any = _decl0_51._shouldForward('pending');
    currVal_22;
    const currVal_23:any = !_decl0_51._animationsEnabled;
    currVal_23;
    const currVal_24:any = !!!_decl0_99.transform(_decl0_57,'editing');
    currVal_24;
    const currVal_25:any = _decl0_99.transform(_decl0_57,'label');
    currVal_25;
    const currVal_26:any = !!_decl0_99.transform(_decl0_57,'editing');
    currVal_26;
    const currVal_27:any = ((!!_decl0_99.transform(_decl0_57,'editing') && !!_decl0_51._control.ngControl) && _decl0_51._control.ngControl.control.invalid);
    currVal_27;
  }
}
function _View_MetaFormGroup_1_12():void {
  var _any:any = (null as any);
  const currVal_0:any = _any;
  currVal_0;
  const currVal_1:any = _any;
  currVal_1;
  const currVal_2:any = !!_decl0_99.transform(_decl0_57,'visible');
  currVal_2;
}
function _View_MetaFormGroup_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'class';
  currVal_0;
  const currVal_1:any = _decl0_81._parentMC;
  currVal_1;
  const currVal_2:any = _decl0_57.hasObject();
  currVal_2;
}
function _View_MetaContentPageComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_MetaContentPageComponent_2_1():void {
  if (_decl0_83.label) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_83.label;
    currVal_0;
  }
}
function _View_MetaContentPageComponent_2_2():void {
  if (_decl0_83.object) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_83.layout;
    currVal_0;
    const currVal_1:any = _decl0_83.operation;
    currVal_1;
    const currVal_2:any = _decl0_83.object;
    currVal_2;
    const currVal_3:any = true;
    currVal_3;
    const currVal_4:any = 'ObjectDetail';
    currVal_4;
  }
}
function _View_MetaContentPageComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_83.label;
  currVal_0;
  const currVal_1:any = _decl0_83.object;
  currVal_1;
}
function _View_MetaActionListComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_MetaActionListComponent_3_3():void {
  if (_decl0_99.transform(_decl0_57,'visible')) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_99.transform(_decl0_57,'disabled');
    currVal_0;
    const currVal_1:any = _decl0_99.transform(_decl0_57,'buttonStyle');
    currVal_1;
    const currVal_2:any = (_decl0_48.disabled || null);
    currVal_2;
    const currVal_3:any = (_decl0_48._animationMode === 'NoopAnimations');
    currVal_3;
    const currVal_4:any = _decl0_48.disabled;
    currVal_4;
    const currVal_5:any = _decl0_99.transform(_decl0_57,'label');
    currVal_5;
    const pd_6:any = ((<any>_decl0_84.actionClicked(_decl0_57.context,_any.name)) !== false);
  }
}
function _View_MetaActionListComponent_3_2():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.name;
  currVal_0;
  const currVal_1:any = _decl0_99.transform(_decl0_57,'visible');
  currVal_1;
}
function _View_MetaActionListComponent_3_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.name;
  currVal_0;
  const currVal_1:any = _decl0_84.actions(_any);
  currVal_1;
}
function _View_MetaActionListComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_84.actionCategories();
  currVal_0;
}
function _View_MetaElementListComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_MetaElementListComponent_4_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.name;
  currVal_0;
  const currVal_1:any = 'box col-xs-12';
  currVal_1;
  const currVal_2:any = _decl0_99.transform(_decl0_57,'elementClass');
  currVal_2;
}
function _View_MetaElementListComponent_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_85.allLayouts;
  currVal_0;
}
